import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

export const Navigation = () => {
  const location = useLocation();
  const isPaymentPage = location.pathname === '/payment' || location.pathname === '/payment/success';
  const [showSolutions, setShowSolutions] = useState(false);
  
  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/services', label: 'Services' },
    { path: '/testimonials', label: 'Testimonials' },
    { path: '/payment', label: 'Pricing' },
    { path: '/enquiry', label: 'Contact' },
  ];

  const solutionsMenu = [
    { path: '/job-seekers', label: 'For Job Seekers' },
    { path: '/enterprise', label: 'For Enterprises' },
    { path: '/profile-building', label: 'Profile Building' },
  ];

  if (isPaymentPage) {
    return (
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white/70 backdrop-blur-xl border-b border-black/5">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <Link to="/" className="font-heading text-2xl font-bold text-primary-main group" data-testid="nav-logo">
            <span className="inline-block">Growth</span>
            <span className="inline-block text-secondary-main">Pop</span>
          </Link>
        </div>
      </nav>
    );
  }

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className="fixed top-0 left-0 right-0 z-50 bg-white/70 backdrop-blur-xl border-b border-black/5"
      data-testid="main-navigation"
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
        <Link to="/" className="font-heading text-2xl font-bold text-primary-main group" data-testid="nav-logo">
          <span className="inline-block">Growth</span>
          <span className="inline-block text-secondary-main">Pop</span>
        </Link>
        
        <div className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              data-testid={`nav-link-${item.label.toLowerCase()}`}
              className={`font-body text-sm uppercase tracking-widest transition-colors hover:text-secondary-main ${
                location.pathname === item.path ? 'text-secondary-main' : 'text-text-secondary'
              }`}
            >
              {item.label}
            </Link>
          ))}
          
          <div 
            className="relative"
            onMouseEnter={() => setShowSolutions(true)}
            onMouseLeave={() => setShowSolutions(false)}
          >
            <button
              className="font-body text-sm uppercase tracking-widest transition-colors hover:text-secondary-main text-text-secondary flex items-center gap-1"
              data-testid="nav-solutions-dropdown"
            >
              Solutions
              <ChevronDown className="w-3 h-3" />
            </button>
            
            {showSolutions && (
              <div className="absolute top-full right-0 mt-2 w-56 bg-white border border-primary-main/10 shadow-xl">
                {solutionsMenu.map((item) => (
                  <Link
                    key={item.path}
                    to={item.path}
                    data-testid={`nav-solution-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
                    className="block px-6 py-3 text-sm text-text-secondary hover:bg-background-main hover:text-primary-main transition-colors"
                  >
                    {item.label}
                  </Link>
                ))}
              </div>
            )}
          </div>
        </div>

        <Link
          to="/enquiry"
          data-testid="nav-cta-button"
          className="bg-primary-main text-white hover:bg-primary-light rounded-none px-6 py-3 uppercase tracking-widest text-xs font-semibold transition-all"
        >
          Get Started
        </Link>
      </div>
    </motion.nav>
  );
};

export default Navigation;